/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import './checkbox.scss';
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';

type Props = {
  label?: string,
  /** 任意文字列の場合string Valueの場合true */
  title?: string | boolean;
  isStop?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

/* TODO チェックボックスにスタイル適用が入る場合は呼出しする。無ければ削除を忘れないこと。 */
export const Checkbox = (props: Props) => {
  const {
    label,
    checked,
    onChange,
    onClick,
    title,
    disabled,
    isStop,
  } = props;

  /* State */
  const [isChecked, setIsChecked] = useState(false);

  /* Memo */
  // const tip = useMemo(() => {
  //   if (!title || !label) return undefined;
  //   return typeof title === 'string' ? title : label;
  // }, [title, label]);
  const tip = useMemo(() => {
    if (title && typeof title === 'string') return title;
    return undefined;
  }, [title]);

  /* Callback */
  const handleClickCheck = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) onChange(e);
      setIsChecked(!isChecked);
    },
    [onChange, isChecked],
  );

  const handleClickStop = useCallback((e: globalThis.React.MouseEvent<HTMLElement>) => {
    if (isStop) e.stopPropagation();
  }, [isStop]);

  useEffect(() => {
    setIsChecked(Boolean(checked));
  }, [checked]);

  return (
    <div className="checkbox" onClick={handleClickStop} title={tip}>
      <label
        className={isChecked ? 'checked' : ''}
        onClick={handleClickStop}
      >
        <input
          className="checkbox__form"
          id="base_checkbox"
          type="checkbox"
          disabled={disabled}
          checked={isChecked}
          onClick={onClick}
          onChange={handleClickCheck}
        />
        {label}
      </label>
    </div>
  );
};
